import {api} from '_api';

import type {Attendance} from "_types/models/Attendance";
import type {Finder, Mutator, Searcher} from '_types/swr';
import type {NoContent, Paginated} from "_types/aspnet";
import type {AttendanceStore, AttendanceUpdate} from "_types/requests/attendance";

import {unwrap} from '_utils/axios';
import {parseKey, parseSearcherKey} from '_utils/swr';
import { CurrentAttendanceSession } from '_types/responses/current-attendance-session';
import { GeneratedChatToken } from '_types/responses/generated-chat-token';

export const searchAttendances: Searcher<Paginated<Attendance>> = async ({queryKey}) => {
    const url = parseSearcherKey(queryKey);
    const response = await api.get<Paginated<Attendance>>(url);

    return await unwrap(response);
};

export const findAttendance: Finder<Attendance> = async ({queryKey}) => {
    const url = parseKey(queryKey);
    const response = await api.get<Attendance>(url);

    return await unwrap(response);
};

export const storeAttendance: Mutator<Attendance, AttendanceStore> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<Attendance>(url, payload);

    return await unwrap(response);
};

export const finishAttendance: Mutator<NoContent> = async (queryKey) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url);

    return await unwrap(response);
};

export const videoAttendance: Mutator<NoContent> = async (queryKey) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url);

    return await unwrap(response);
};

export const currentAttendanceSession: Finder<CurrentAttendanceSession> = async ({queryKey}) => {
    const url = parseKey(queryKey);
    const response = await api.get<CurrentAttendanceSession>(url);

    return await unwrap(response);
};

export const startAttendanceSession: Mutator<CurrentAttendanceSession> = async (queryKey) => {
    const url = parseKey(queryKey);
    const response = await api.post<CurrentAttendanceSession>(url);

    return await unwrap(response);
};

export const endAttendanceSession: Mutator<NoContent> = async (queryKey) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url);

    return await unwrap(response);
};

export const chatToken: Mutator<GeneratedChatToken> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<GeneratedChatToken>(url, payload);
    return await unwrap(response);
}
